var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"content-class":"bg-white","width":_vm.parsedWidth,"value":_vm.value,"persistent":_vm.persistent},on:{"input":_vm.emitInput}},[_c('v-card',{staticClass:"px-8 py-6"},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default",null,null,{close: _vm.close})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }